import React from "react"
import styled from "styled-components"

const ColorWrapper = styled.div`
    width:80%;
    display:flex;
    flex-wrap:wrap;
    justify-content: center;
    margin: 0 auto;
`
const ColorItem = styled.img`
    width:120px;
    height:120px;
    margin:9px;
`
const ColorName = styled.h2`
text-align:center;
`

class TextilesColors extends React.Component {

  render() {
   let color = this.props.groupInfo
    return (
      <>
       <ColorName>{color.groupName}</ColorName>
        <ColorWrapper>        
           {color.images.map((item)=>{          
             return <ColorItem key= {item.title} alt={item.title} src={item.file.url} onClick={this.props.setColor} />
           })}
        </ColorWrapper>
      </>
    )
  }
}

export default TextilesColors
